import { useState } from "react";

const ShareCard = ({ report, onShareClick }) => {
  const [shareCopied, setShareCopied] = useState(false);

  const copyShareLink = async (url) => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      setShareCopied(true);
      setTimeout(() => setShareCopied(false), 1600);
    } catch {
      // Fallback: could use document.execCommand or show text to copy
      alert("Could not copy link automatically. Please copy it manually.");
    }
  };

  const shareUrl = `${window.location.origin}${report.share_url.startsWith("/") ? report.share_url : `/report/${report.share_url}`}`;

  return (
    <div className="card" style={{ margin: "20px 0", background: "#f8fafc", borderColor: "var(--border-focus)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 16 }}>
        <div>
          <strong style={{ display: "block", marginBottom: 4 }}>Share this public report</strong>
          <div style={{ fontSize: "0.85rem", color: "var(--text-muted)", marginBottom: 8 }}>
            Copy this link and send it to your team or clients to review the audit.
          </div>
          <a
            style={{ wordBreak: "break-all" }}
            href={shareUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {shareUrl}
          </a>
        </div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button
            className="btn btn-ghost"
            onClick={() => copyShareLink(shareUrl)}
            aria-label="Copy share link"
          >
            {shareCopied ? "Copied!" : "Copy Link"}
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              if (typeof onShareClick === "function") {
                onShareClick();
                return;
              }
              window.open(shareUrl, "_blank", "noopener,noreferrer");
            }}
            aria-label="Open share report"
          >
            Open Report
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareCard;
